/**
 * Dealroom's own URLs are addressed by a slug, not by the id we store.
 *
 * `app.dealroom.co/investors/1775723` does not resolve; `.../investors/localglobe`
 * does. The id identifies which row a fund is and the path addresses its page,
 * and nothing derives one from the other — so a link is something we either
 * hold the path for or do not offer at all. A page that 404s is worse than a
 * line of text saying which id to look up.
 */
const APP_BASE = 'https://app.dealroom.co';
/**
 * A path we will build a URL out of, or null.
 *
 * All digits is the case worth naming: an id that found its way into the path
 * column would build exactly the URL this exists to stop. Everything else
 * Dealroom sends is taken as it comes — the slugs are theirs, not ours to
 * police — beyond trimming and refusing a slash, which would leave the
 * `/investors/` prefix pointing somewhere else entirely.
 */
export function dealroomPath(path) {
    const trimmed = path?.trim() ?? '';
    if (trimmed === '')
        return null;
    if (/^\d+$/.test(trimmed))
        return null;
    if (trimmed.includes('/'))
        return null;
    return trimmed;
}
/** The fund's, or the candidate's, page on Dealroom. Null where the path is. */
export function dealroomInvestorUrl(path) {
    const slug = dealroomPath(path);
    return slug === null ? null : `${APP_BASE}/investors/${encodeURIComponent(slug)}`;
}
/** The company's page on Dealroom. Null where the path is. */
export function dealroomCompanyUrl(path) {
    const slug = dealroomPath(path);
    return slug === null ? null : `${APP_BASE}/companies/${encodeURIComponent(slug)}`;
}
/** What to say instead of a link: the id, so somebody can look the row up. */
export function dealroomIdText(dealroomId) {
    return `Dealroom id ${dealroomId}`;
}
//# sourceMappingURL=dealroomLink.js.map